<template>
  <div v-if="sharing && sharing.to && sharing.to.length" class="text-align-left">
    Shared with:
    <div v-for="(sharedTo, index) in sharing.to" :key="index">
      <customer v-if="sharedTo.type === 'customer'" :id="sharedTo.customer" />
      <user v-if="sharedTo.type === 'user'" :id="sharedTo.user" />
    </div>
  </div>
</template>

<script>
import customerComponentVue from '../apolloQueryComponents/customerComponent.vue';
import userComponentVue from '../apolloQueryComponents/userComponent.vue';
export default {
  name: 'SharingComponent',
  components: {
    customer: customerComponentVue,
    user: userComponentVue
  },
  props: {
    intitialSharing: Object
  },
  data() {
    return {
      sharing: this.intitialSharing
    };
  }
};
</script>

<style></style>
